import { takeLatest } from 'redux-saga/effects'
import {updateAddress} from 'redux/slices/prescriptionSlice'
import {
  createOrder,
  sendQuotation,
  getViberPrescription,
  updateName,
  addAddress,
  createPrescriptions,
  getPharmacyPrescription,
  getScannedPrescriptionOrder,
  deletePrescription,
  confirmOrder,
  cancelOrder
} from 'redux/slices/prescriptionSlice'
import {
  handleViberPrescriptionGet,
  handleUpdateName,
  handleCreateOrder,
  handleScannedPrescriptionGet,
  handlePrescriptionInfoGet,
  handleCreatePrescription,
  handleNewAddAddress,
  handleDeletePrescription,
  handleConfirmOrder,
  handleSendQuotation,
  handleCancelOrder,
  handleUpdateAddress
} from '../handlers/prescriptionHandler'

const prescriptionSaga = [
  takeLatest(getViberPrescription.type, handleViberPrescriptionGet),
  takeLatest(updateName.type, handleUpdateName),
  takeLatest(createOrder.type, handleCreateOrder),
  takeLatest(getScannedPrescriptionOrder.type, handleScannedPrescriptionGet),
  takeLatest(getPharmacyPrescription.type, handlePrescriptionInfoGet),
  takeLatest(createPrescriptions.type, handleCreatePrescription),
  takeLatest(addAddress.type, handleNewAddAddress),
  takeLatest(deletePrescription.type, handleDeletePrescription),
  takeLatest(confirmOrder.type, handleConfirmOrder),
  takeLatest(sendQuotation.type, handleSendQuotation),
  takeLatest(cancelOrder.type, handleCancelOrder),
  takeLatest(updateAddress.type, handleUpdateAddress)
]

export default prescriptionSaga
